import {useNavigate, useParams} from 'react-router-dom';
import Button from '../../../../components/button';
import DotsLoading from '../../../../components/dotsLoading';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import NoData from '../../../../components/noData';
import useGetBrandDetailById from '../../../../services/hookService/getBrandDetailById/useGetBrandDetailById';
import useGetDetailedSubBrandList from '../../../../services/hookService/getDetailedSubBrandList/UseGetDetailedSubBrandListProps';
import useGetSubBrandOwner from '../../../../services/hookService/getSubBrandOwner/useGetSubBrandOwner';
import {sortByStatus} from '../../../../utilities/helper/sortByStatus';
import StoreDetailHeader from '../StoreDetailHeader';
import ProductCard from './ProductCard';

const BrandProducts = () => {
  const navigate = useNavigate();
  const {brandId} = useParams();

  const isOwner = window.location.href.includes('my-store-brands');

  const {data: BrandDetails, isLoading: isBrandDetailsLoading} =
    useGetBrandDetailById(brandId);

  // Owner Products
  const {data: ownerSubBrands, isLoading: isLoadingOwnerSubBrands} =
    useGetSubBrandOwner({brandId: +brandId!, enabled: isOwner});

  // Other Products
  const {
    data: subBrandData,
    isLoading: isLoadingSubBrands,
    loaderRef,
    isFetchingNextPage,
  } = useGetDetailedSubBrandList({brandId: +brandId!, enabled: !isOwner});

  const dataToRender = isOwner ? ownerSubBrands : subBrandData;

  const isLoading =
    isBrandDetailsLoading || isLoadingSubBrands || isLoadingOwnerSubBrands;

  if (isLoading)
    return (
      <div className="grid place-content-center min-h-dvh">
        <DotsLoading />
      </div>
    );

  return (
    <div className="flex relative flex-col w-full h-screen">
      <div>
        <CustomHeader
          title={BrandDetails?.name ?? ''}
          preIcon="icon-nameArrow---Right"
          onClick={() => navigate(-1)}
          isActiveRightIcon
        />
      </div>

      <div className="flex overflow-y-auto flex-col gap-3 mb-10 w-full">
        <StoreDetailHeader logo={BrandDetails?.logo || ''} />
        <div className="p-4">
          <span className="text-gray-800">محصولات</span>

          {!dataToRender?.length ? (
            <div className="flex justify-center items-center mt-36">
              <NoData text="تا کنون هیچ محصولی برای این برند ثبت نشده است" />
            </div>
          ) : (
            <div className="mt-2 mb-20 space-y-3">
              {dataToRender
                ?.sort((a, b) => sortByStatus(a, b))
                ?.map(item => (
                  <ProductCard key={item.guid} item={item} isOwner={isOwner} />
                ))}

              <div ref={loaderRef} className="mt-4 text-center">
                {isFetchingNextPage ? <DotsLoading /> : null}
              </div>
            </div>
          )}

          {isOwner && (
            <Button
              onClick={() => navigate(`/create-brand/${brandId}/add-product`)}
              className="fixed right-4 left-4 bottom-6"
            >
              افزودن محصول جدید
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandProducts;
